/**
 * i18n — Français (fr) ✅ COMPLETE
 */

const fr = {
  appTitle: 'Tarkov Money Maker 2',
  modeBadgePvp: 'Permanent',
  modeBadgePve: 'Co-op',
  modeBadgeSeason: 'Saison 1',
  loading: 'Chargement',
  filterSearchLabel: 'Recherche',
  filterSearchPlaceholder: "Nom d'item, Entrée ou clic…",
  filterSearchAddTerm: 'Ajouter un autre terme…',
  filterSearchAdd: 'ajouter',
  filterProfitLabel: 'Profit min.',
  filterLevelLabel: 'Niveau joueur',
  filterOffersLabel: 'Offres min.',
  filterOffersDisabled: "L'API ne fournit pas le nb d'offres pour ce mode. Filtre désactivé.",
  traderEnable: 'activer',
  traderDisable: 'désactiver',
  intelNotBuilt: 'Non construit',
  intelLevel1: 'Niveau 1',
  intelLevel2: 'Niveau 2',
  intelLevel3: '-30% taxe flea',
  colItem: 'Item',
  colBuyTrader: 'Achat Trader',
  colSellTrader: 'Vente Trader',
  colAction: 'Action',
  colBestProfit: '★ Meilleur profit',
  colTraderFlea: 'Trader→Flea',
  colFleaTrader: 'Flea→Trader',
  colFlea: 'Flea',
  copyToast: 'Copié !',
  tooltipBuyPrices: "Prix d'achat chez les traders",
  tooltipSellPrices: 'Prix de rachat',
  flea24h: 'Flea — 24h',
  fleaCur: 'Actuel',
  fleaLow: 'Bas 24h',
  fleaAvg: 'Moy 24h',
  fleaHigh: 'Haut 24h',
  fleaOffers: 'offres',
  recFTS: 'Acheter Flea → Vendre Trader',
  recBTF: 'Acheter Trader → Vendre Flea',
  cardBuy: 'Achat',
  cardSell: 'Vente',
  cardOffers: 'offres',
  paginationOf: 'sur',
  paginationPerPage: 'Par page :',
  paginationPage: 'Page',
  paginationTapSort: 'Appuie pour trier',
  noItems: 'Aucun item profitable trouvé. Diminue le seuil ou active plus de traders.',
  chartTitle: 'Flea — snapshot 24h',
  chartNoData: 'Données insuffisantes',
  apiStatusTitle: 'Statut de synchronisation',
  apiStatusOnline: 'tarkov.dev Online',
  apiStatusDegraded: 'tarkov.dev Dégradé',
  apiStatusOffline: 'tarkov.dev Offline',
  apiStatusChecking: 'Vérification…',
  apiStatusGlobal: 'Statut global',
  apiStatusLastSync: 'Dernière sync',
  apiStatusItems: 'Items synchronisés',
  apiStatusItemsSub: 'total cumulé',
  apiStatusSource: 'Source API',
  apiStatusSourceSub: 'check auto toutes les 30s',
  apiStatusCheckedAt: 'Vérifié',
  apiStatusModeStatus: 'Statut',
  apiStatusModeItems: 'Items',
  apiStatusModeLastSync: 'Dernière sync',
  apiStatusModeDuration: 'Durée',
  apiStatusNever: 'jamais',
  apiStatusJustNow: 'à l\'instant',
  apiStatusTimeAgoPrefix: 'il y a',
  apiStatusMinutesAgo: 'min',
  apiStatusHoursAgo: 'h',
  apiStatusRest: 'REST',
  exportCSV: 'Exporter en CSV',
  exportJSON: 'Exporter en JSON',
  histFleaPrice: 'Prix Flea — 24 dernières heures',
  histOffers: 'Offres disponibles — 24 dernières heures',
  histLoading: 'Chargement de l\'historique…',
  histNoData: 'Pas encore de données historiques — elles s\'accumulent après chaque sync.',
  histError: 'Serveur injoignable — les données historiques seront disponibles une fois le backend démarré.',
};

export default fr;
